module.exports = __webpack_public_path__ + "abfb27caa02f0abd1ff68b06dbddfb7b.svg";